import { Component, OnInit, Input, Optional } from "@angular/core";
import { CtaButtonFeaturesComponent } from "../cta-button-features/cta-button-features.component";
import { CtaButtonGroupControlComponent } from "../cta-button-group-control/cta-button-group-control.component";

@Component({
    selector: "dodo-cta-button-features-group",
    templateUrl: "./cta-button-features-group.component.html",
    styleUrls: ["./cta-button-features-group.component.scss"],
    standalone: false
})
export class CtaButtonFeaturesGroupComponent implements OnInit {
	@Input() activeFeatureId: string | number;
	_features: CtaButtonFeaturesComponent[] = [];

	constructor(
		@Optional()
		private __buttonsGroupControl: CtaButtonGroupControlComponent
	) {}

	ngOnInit() {
		if (this.__buttonsGroupControl) {
			this.__buttonsGroupControl.registerFeaturesGroup(this);
		}
	}

	addFeatures(features: CtaButtonFeaturesComponent) {
		features.active = features.id === this.activeFeatureId;
		this._features.push(features);
	}

	setFeatureActive(featureId: string | number) {
		this.activeFeatureId = featureId;
		this._features.forEach(f => (f.active = f.id === featureId));
	}
}
